import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import { hideVariants } from '../store/productSlice';
import { useEffect, useState } from 'react';
import CartAdd from '/asset/shopping-basket.svg';
import { PurchaseItem } from '../interfaces';
import { updatePurchaseCartAsync } from '../store/purchaseSlice';
import CancelIcon from '/asset/closeicon.svg';
import { formatCurrency } from '../utils';

export default function Variants() {
  const dispatch = useDispatch<AppDispatch>();
  const [cart, setCart] = useState<PurchaseItem[]>([]);
  const purchaseData = useSelector(
    (state: RootState) => state.purchase.purchase
  );
  const { variants } = useSelector((state: RootState) => state.products);
  const addToCart = async (cartItem: {
    code: string;
    name: string;
    quantity: number;
    productVariantId: number;
    specialRequest: string;
    image: string;
    description: string;
    unitPrice: number;
  }) => {
    // eslint-disable-next-line prefer-const
    let thisCart = [...cart];
    // eslint-disable-next-line prefer-const
    let CartLineItems: PurchaseItem[] = [];
    const {
      quantity,
      productVariantId,
      specialRequest,
      image,
      description,
      code,
      name,
      unitPrice,
    } = cartItem;
    const index = thisCart.findIndex(
      (item) => item.productVariantId === productVariantId
    );
    if (quantity > 0 && index < 0) {
      thisCart.push({
        unitPrice: unitPrice,
        quantity: 1,
        code: code,
        name: name,
        rewardsValue: 0,
        productVariantId: productVariantId,
        paymentStatus: '',
        specialRequest: specialRequest,
        image: image,
        description: description,
      });
    }
    if (thisCart.length > 0) {
      for (let i = 0; i < thisCart.length; i++) {
        let this_item: PurchaseItem = thisCart[i];
        if (index === i && quantity > 0) {
          this_item = { ...thisCart[i], quantity: thisCart[i].quantity + 1 };
        }
        if ((quantity > 0 && index === i) || index !== i) {
          CartLineItems.push(this_item);
        }
      }
    }
    const purchaseCode = '';
    dispatch(updatePurchaseCartAsync({ CartLineItems, purchaseCode }));
  };
  useEffect(() => {
    if (purchaseData) {
      if (purchaseData.purchases) {
        setCart(purchaseData.purchases);
      }
    }
  }, [purchaseData]);
  return (
    <div className="fixed inset-0 z-[200] flex items-end sm:items-center px-0 sm:px-[20px] justify-center bg-black/50">
      <div className="rounded-t-2xl sm:rounded-2xl w-full max-w-xl shadow-xl relative bg-gray-100 max-h-[85%] flex flex-col">
        {/* Header */}
        <div
          className="flex items-center justify-between
         px-5 pt-5 pb-3 shrink-0
         mb-[20px]"
        >
          <h2 className="text-[16px] font-medium text-gray-900">
            Product Options
          </h2>
          <div
            className="w-[28px] h-[28px] flex 
            items-center justify-center 
            rounded-full bg-transparent 
            cursor-pointer border-none outline-none"
            onClick={() => variants && dispatch(hideVariants())}
          >
            <img src={CancelIcon} alt="Close" className="w-[14px] h-[14px]" />
          </div>
        </div>

        {/* Scrollable list */}
        <div className="overflow-y-auto px-5 pb-5 flex flex-col gap-3">
          {variants &&
          variants.variants.filter((v) => v.isActive).length > 0 ? (
            variants.variants
              .filter((variant) => variant.isActive)
              .map((variant) => {
                const exists = cart.filter(
                  (item) => item.productVariantId === variant.id
                );
                const existsInCart = exists.length > 0;
                const quantity = exists.length > 0 ? exists[0].quantity : 0;
                return (
                  <div
                    key={variant.id}
                    className="w-full bg-white rounded-xl shadow-sm px-4 py-4 flex flex-col gap-2"
                  >
                    {/* Variant name */}
                    <p className="text-[14px] font-medium text-gray-900 leading-snug">
                      {variant.sku}
                    </p>

                    {/* Price + button row */}
                    <div className="flex items-center justify-between gap-3">
                      <span className="text-[14px] font-medium text-secondary-500">
                        {formatCurrency(variant.unitPrice || 0)}
                      </span>

                      <button
                        className="relative flex items-center gap-2 
                      bg-secondary-500 hover:bg-secondary-700 text-white 
                      text-[11px] font-bold uppercase tracking-wide 
                      rounded-sm px-4 py-2 cursor-pointer border-none outline-none transition-colors"
                        onClick={() => {
                          if (variant) {
                            addToCart({
                              quantity: 1,
                              specialRequest: '',
                              productVariantId: variant.id,
                              code: variants.code,
                              name: variants.name,
                              image: variants.images[0]
                                ? variants.images[0]
                                : '',
                              description: variants.description,
                              unitPrice: variant.unitPrice,
                            });
                          }
                        }}
                      >
                        {existsInCart && (
                          <span className="absolute -top-2 -right-2 min-w-[18px] h-[18px] rounded-full bg-sunset-500 px-1 flex items-center justify-center text-black text-[9px] font-bold leading-none">
                            {quantity}
                          </span>
                        )}
                        Add to Cart
                        <img src={CartAdd} className="w-[15px] h-[15px]" />
                      </button>
                    </div>
                  </div>
                );
              })
          ) : (
            <div className="text-[16px] max-w-[400px] m-auto font-[500] text-center text-primary-700 py-8">
              No variants available
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
